import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const triggerElement = '#js-BackgroundGsap'

if(document.querySelector(triggerElement)){
  gsap.to("body", {
    scrollTrigger: {
      trigger: triggerElement,
      once: false,
      scrub: true,
      start: "200 bottom",
      end: "+=400",
   },
    backgroundColor: "#0D0D0D",
  });
}
